"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopConnection = exports.clearOnReceiveMessage = exports.onReceiveMessage = exports.startConnection = void 0;
var signalr_1 = require("@microsoft/signalr");
var lodash_1 = require("lodash");
var types_1 = require("../types");
var useSignalRNegotiation_1 = require("./useSignalRNegotiation");
var messageCallbacks = {};
var retryDelays = [1000, 5000, 10000];
var retryPolicy = {
    nextRetryDelayInMilliseconds: function (retryContext) {
        if (retryContext.previousRetryCount > retryDelays.length - 1)
            return retryDelays[retryDelays.length - 1];
        return retryDelays[retryContext.previousRetryCount];
    },
};
var startConnection = function (baseUrl, onChangeListenerRef, connectionRef) { return __awaiter(void 0, void 0, void 0, function () {
    var initialNegotiation, hubUrl, error_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 4, , 5]);
                console.log("SignalR => Starting connection...");
                (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.Connecting);
                return [4 /*yield*/, (0, useSignalRNegotiation_1.signalRNegotiation)({ baseUrl: baseUrl })];
            case 1:
                initialNegotiation = _d.sent();
                if (!(initialNegotiation === null || initialNegotiation === void 0 ? void 0 : initialNegotiation.url)) {
                    console.error("SignalR => Invalid negotiation response: ", initialNegotiation);
                    (_b = onChangeListenerRef.current) === null || _b === void 0 ? void 0 : _b.call(onChangeListenerRef, types_1.ConnectionStatus.Error, new Error("Invalid negotiation response"));
                    return [2 /*return*/];
                }
                hubUrl = initialNegotiation.url;
                console.info("SignalR => negotiation successful. Hub URL: ", hubUrl);
                if (!connectionRef.current) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.stopConnection)(onChangeListenerRef, connectionRef)];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3:
                connectionRef.current = new signalr_1.HubConnectionBuilder()
                    .withUrl(hubUrl, {
                    accessTokenFactory: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var response, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    console.log("SignalR => Refreshing access token...");
                                    return [4 /*yield*/, (0, useSignalRNegotiation_1.signalRNegotiation)({ baseUrl: baseUrl })];
                                case 1:
                                    response = _a.sent();
                                    if (!(response === null || response === void 0 ? void 0 : response.accessToken)) {
                                        console.error("SignalR => Unable to refresh access token");
                                        return [2 /*return*/, ""];
                                    }
                                    return [2 /*return*/, response.accessToken];
                                case 2:
                                    error_2 = _a.sent();
                                    console.error("SignalR => Error refreshing access token: ", error_2);
                                    return [2 /*return*/, ""];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); },
                })
                    .withAutomaticReconnect(retryPolicy)
                    .configureLogging(signalr_1.LogLevel.Information)
                    .build();
                connectionRef.current.on("SignalRMessage", function (message) {
                    Object.keys(messageCallbacks).forEach(function (key) { return messageCallbacks[key](message); });
                });
                connectionRef.current.onclose(function (error) {
                    var _a;
                    console.log("SignalR connection closed:", error);
                    (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.Error, error);
                });
                connectionRef.current.onreconnecting(function (error) {
                    var _a;
                    console.log("SignalR connection reconnecting...", error);
                    (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.ReConnecting);
                });
                connectionRef.current.onreconnected(function (connectionId) {
                    var _a;
                    console.log("SignalR connection reconnected. New connection ID:", connectionId);
                    (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.Connected);
                });
                connectionRef.current
                    .start()
                    .then(function () {
                    var _a;
                    console.log("SignalR => Connection established!");
                    (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.Connected);
                })
                    .catch(function (err) {
                    var _a;
                    console.error("SignalR => Error starting connection:", err);
                    (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.Error, err);
                });
                return [3 /*break*/, 5];
            case 4:
                error_1 = _d.sent();
                console.error("SignalR => Error occurred: ", error_1);
                (_c = onChangeListenerRef.current) === null || _c === void 0 ? void 0 : _c.call(onChangeListenerRef, types_1.ConnectionStatus.Error, error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.startConnection = startConnection;
var onReceiveMessage = function (callback) {
    var callbackId = (0, lodash_1.uniqueId)();
    messageCallbacks[callbackId] = callback;
    return callbackId;
};
exports.onReceiveMessage = onReceiveMessage;
var clearOnReceiveMessage = function (callbackId) {
    delete messageCallbacks[callbackId];
};
exports.clearOnReceiveMessage = clearOnReceiveMessage;
var stopConnection = function (onChangeListenerRef, connectionRef) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!connectionRef.current) return [3 /*break*/, 5];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, connectionRef.current.stop()];
            case 2:
                _d.sent();
                console.log("SignalR => Connection stopped.");
                (_a = onChangeListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeListenerRef, types_1.ConnectionStatus.Disconnected);
                return [3 /*break*/, 4];
            case 3:
                err_1 = _d.sent();
                console.error("SignalR => Error stopping connection:", err_1);
                (_b = onChangeListenerRef.current) === null || _b === void 0 ? void 0 : _b.call(onChangeListenerRef, types_1.ConnectionStatus.Error, err_1);
                return [3 /*break*/, 4];
            case 4: return [3 /*break*/, 6];
            case 5:
                console.log("SignalR => Connection already stopped.");
                (_c = onChangeListenerRef.current) === null || _c === void 0 ? void 0 : _c.call(onChangeListenerRef, types_1.ConnectionStatus.Disconnected);
                _d.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.stopConnection = stopConnection;
